import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import {environment} from '../../../environments/environment'
import { AddCoboPayload } from '../helpers/interfaces'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { RuntimeConfigService } from '../../../app/runtime-config.service'

const baseUrl = environment.ACCOUNT_HOST_URL

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  //api_cdn_url: string = environment.API_CDN_URL
  api_cdn_url: string;
  loan_quote_url: string = environment.LOAN_QUOTE_URL
  articles_url: string = environment.ARTICLES_URL
  articles_authors_url: string = environment.ARTICLES_AUTHORS_URL
  send_app_url: string = environment.SEND_APP_URL
  provider_api_url: string = environment.PROVIDER_API_BASE_URL
  trustpilot_public: string = this.runtimeConfigService.trustPilotPublicKey //environment.TRUSTPILOT_PUBLIC_KEY || ''
  trustpilot_secret: string = this.runtimeConfigService.trustPilotSecretKey  //environment.TRUSTPILOT_SECRET_KEY || ''
  trustpilot_id: string = this.runtimeConfigService.trustPilotId  //environment.ICW_TRUSTPILOT_ID || ''
  modalPopupText = ''
  modalPopupTextMobile = ''
  equipmentProviderInActive: boolean
  constructor(private http: HttpClient, public sharedDataService: SharedDataService,  
     private runtimeConfigService: RuntimeConfigService,
) {
    this.equipmentProviderInActive = this.sharedDataService.getPortalType();
    if(this.equipmentProviderInActive){
      this.api_cdn_url = environment.API_EQUIP_PROVIDER_CDN_URL
    } else {
      this.api_cdn_url = environment.API_DENTAL_CDN_URL
    }

   }

  // getPages(): Observable<any>{
  //   return this.http.get<any>(`${this.api_cdn_url}/pages`)
  // }
   
  getHomePage(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/pages/home-page?populate=deep`)
  }
  getActivationPage(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/pages/account-activation?populate=deep`)
  }
  getWhyUsPage(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/pages/why-us?populate=deep`)
  }
  getExperiencePage(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/pages/credit-tool?populate=deep`)
  }
  getPoliciesPage(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/pages/policy?populate=deep`)
  }
  getFaq(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/pages/faq?populate=deep`)
  }
  getLicensures(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/licensure-list?populate=deep`)
  }
  getSearchOptions(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/search-options?populate=deep`)
  }
  getFooter(): Observable<any>{
    return this.http.get<any>(`${this.api_cdn_url}/pages/footer?populate=deep`)
  }

  getArticles(): Observable<any>{
    const body = {
      limit: 10,
      skip: 0
  }
    return this.http.post<any>(`${this.articles_url}/account/v1/user/content/credit/articles`, body)
  }

  loanOptionSelection(body: any): Observable<any> {
    return this.http.post(`${this.loan_quote_url}/application/v1/loan/options/select`, body)
  }

  addCobo(body: AddCoboPayload): Observable<any> {
    return this.http.post(`${this.loan_quote_url}/application/v1/cobo/request`, body)
  }

  loanQuote(info: any): Observable<any>{
    return this.http.post(`${this.loan_quote_url}/application/v1/underwriting/loan/quote`, info)
  }

  getPhoneConsult(phone: string): Observable<any> {
    let phoneWitoutHypens = phone.replace(/-/g, '')
    return this.http.get(`${this.loan_quote_url}/provider/v1/consultation/rpPhone/${phoneWitoutHypens}`)
  }

  getConsentCodes(): Observable<any> {
    return this.http.get(`${this.loan_quote_url}/security/v1/consents`)
  }

  getProbeLanding(phoneNumber: string){
    return this.http.get(`${this.loan_quote_url}/application/v1/loan/info/${phoneNumber}`)
  }

  getDentistFiltersInfo(): Observable<any> {
    return this.http.get(`${this.articles_url}/user/v1/staticData`)
  }

  getDentistList(body): Observable<any> {
    return this.http.post(`${this.articles_authors_url}/doctorpractice/search`, body)
  }

  getConsultationInfo(): Observable<any>{
    return this.http.get(`${this.send_app_url}/applicant/info`)
  }

  sendSelectDentist(body): Observable<any>{
    return this.http.post(`${this.articles_url}/account/v1/user/loan/chosen/provider`, body)
  }

  reScoreLoanAmount(body): Observable<any>{
    return this.http.post(`${this.articles_url}/application/v1/underwriting/loan/re-score`, body)
  }

  getLoanOptions(userId, loanId): Observable<any> {
    // {{baseUrl}}/api/application/v1/loan/options
    // userId={{userId}}&loanId={{loanId}}
    return this.http.get(`${this.loan_quote_url}/application/v1/loan/options?userId=${userId}&loanId=${loanId}`)
  }

  rePullFreezeSyntetic(body, transactionId): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'x-icw-synthetic-transaction-id': transactionId
      }),
    }
    return this.http.post(`${this.loan_quote_url}/application/v1/underwriting/loan/re-pull`, body, options)
  }

  rePullFreeze(body: any): Observable<any>{
    return this.http.post(`${this.loan_quote_url}/application/v1/underwriting/loan/re-pull`, body)
  }

  getArticleAuthor(authorId: string): Observable<any>{
    const params = new HttpParams().set('query', authorId)
    return this.http.get<any>(`${this.articles_authors_url}/authors`, {params})
  }

  getExternalHTML(url: string){
    return this.http.get(url, {responseType: 'text'})
  }

  sendAppLinkObj(body: any): Observable<any>{
    return this.http.post<any>(`${this.send_app_url}/send/app-link`, body)
  }

  sendJoinICW(body: any): Observable<any>{
    // application/v1/send/join-icw
    return this.http.post<any>(`${this.send_app_url}/send/join-icw`, body)
  }
  sendJoinICWPrepared(email: string): Observable<any>{
    const body = {
      emailAddress: email,
      phone: '',
      loanAcctId: '',
      cobo: false,
    }
    return this.sendJoinICW(body)
  }

  checkStateAvailable(state: string): Observable<any> {
    const body = { state }
    return this.http.post<any>(`${this.loan_quote_url}/application/v1/loan/service`, body)
  }

  getStates(): Observable<any> {
    return this.http.get<any>(`${this.loan_quote_url}/list/v1/states`)
  }
  
  getGlobalVars(): Observable<any>{
    return this.http.get<any>(`${this.loan_quote_url}/system/v1/config/global/var`)
  }

  getTrustpilotId(): Observable<any> {
    const businessName = 'icreditworks.com'
    const params = new HttpParams().set('apikey', this.trustpilot_public)
    return this.http.get(`https://api.trustpilot.com/v1/business-units/find?name=${businessName}`, {params})
  }

  getTrustpilotReviews(): Observable<any> {
    const params = new HttpParams().set('apikey', this.trustpilot_public)
    return this.http.get(`https://api.trustpilot.com/v1/business-units/${this.trustpilot_id}/reviews`, {params})
  }
}
